import { CButton } from '@coreui/react-pro'
import React from 'react'
import {FaCertificate, FaElementor} from "react-icons/fa";
import {CgNotes, CgWorkAlt} from "react-icons/cg";
import {BsClock} from "react-icons/bs";
import {BiDiamond, BiMoney} from "react-icons/bi";

const CourseInfoCard = () => {
  return (
    <div className="px-2 px-lg-4">
      <div className="course-info-card-inner w-70 bg-blue">
        {/* <CCardImage orientation="top" src="/images/react.jpg" /> */}
        <div className="p-4 pb-1">
          <CButton className="normal-btn px-5 py-2 mb-2 text-white w-100 fs-5 rounded-0">
            <strong>Apply Now</strong>
          </CButton>
          <div>
            <h6>
              <strong>This course includes:</strong>
            </h6>
            <div className="d-flex align-items-center">
              <BsClock/>
              <div className="px-3">24 hour access to coding platform</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <BsClock/>
              <div className="px-3">24 hour live-chat platform</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <FaElementor/>
              <div className="px-3">Guardianship/mentorship available</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <CgWorkAlt/>
              <div className="px-3">Part-time and full-time training</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <CgNotes/>
              <div className="px-3">Extra-curricular activities</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <FaCertificate/>
              <div className="px-3">Certificate of completion</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <BiMoney/>
              <div className="px-3">Opportunity for paid internship</div>
            </div>
            <div className="d-flex align-items-center pt-1">
              <BiDiamond/>
              <div className="px-3">Opportunity for employment</div>
            </div>
          </div>
          {/*<div className="mt-4 mb-0">*/}
          {/*  <div>*/}
          {/*    <svg*/}
          {/*      xmlns="http://www.w3.org/2000/svg"*/}
          {/*      width="16"*/}
          {/*      height="16"*/}
          {/*      fill="currentColor"*/}
          {/*      className="bi bi-share-fill"*/}
          {/*      viewBox="0 0 16 16"*/}
          {/*    >*/}
          {/*      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />*/}
          {/*    </svg>*/}
          {/*    <span className="ms-3 ">Share</span>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        <hr />

        <div className="p-4 pt-2">
          {/*<div>*/}
          {/*  <h5>*/}
          {/*    <strong>Sponsor a Student Today</strong>*/}
          {/*  </h5>*/}
          {/*  <div>Get your team access to 19,000+ top OurAkademy courses anytime, anywhere.</div>*/}
          {/*</div>*/}
          <CButton className="px-5 py-2 mt-2 text-black border border-dark bg-white w-100  rounded-0">
            <strong>Sponsor Now</strong>
          </CButton>
        </div>
      </div>
    </div>
  )
}

export default CourseInfoCard
